/**
 * Date.prototype.formatRange(String endString)
 *
 * Returns a string range between two dates
 */
Date.prototype.formatRange = function (dates, show_day_names = true) {

    var result = "";
    if(dates instanceof Array) {
        var months = [];
        dates.forEach((date, key) => {
            date = new Date(date);
            date.setTime( date.getTime() + date.getTimezoneOffset()*60*1000 );

            if(months[date.getMonth()] == undefined)
                months[date.getMonth()] = [];

            months[date.getMonth()].push(date);
        });
        months.forEach((month, step) => {
            month.forEach((date, key) => {
                result += (show_day_names ? date.getStrDay('short') + ' ' : '') + date.getDate().nth() + (key == month.length-1 ? ' ' + date.getStrMonth('short') + (key == month.length-1 && step != months.length-1 ? ', ' : '') : '') + (key == month.length-1 && step == months.length-1 ? ' ' + date.getFullYear() : '') + ((key == month.length-1) ? '' : ', ');
            })
        })

    } else {
        var end = new Date((dates instanceof Array && dates.length == 1 ? dates[0] : dates));
        end.setTime( end.getTime() + end.getTimezoneOffset()*60*1000 );

        if(! end.isValid() )
            return result;

        result = (show_day_names ? this.getStrDay('short') + ' ' : '') + this.getDate().nth() +
            ' - ' + (show_day_names ? end.getStrDay('short') + ' ' : '') + end.getDate().nth() + ' ' + end.getStrMonth('short');
    }

    return result;
}

/**
 * Date.prototype.getStrMonth(String type)
 *
 * Returns a string representation of the dates month
 */
Date.prototype.getStrMonth = function (type = 'long') {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if(type == 'short')
        return months[this.getMonth()].substr(0, 3);
    else
        return months[this.getMonth()];
}

/**
 * Date.prototype.getStrDay(String type)
 *
 * Returns a string representation of the dates month
 */
Date.prototype.getStrDay = function (type = 'long') {
    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    var day = (this.getDay() == 0 ? 7 : this.getDay());
    if(type == 'short')
        return days[day-1].substr(0, 3);
    else
        return days[day-1];
}

/**
 * Date.prototype.getWeek()
 *
 * Returns the week of the month the date is currently on
 */
Date.prototype.getWeek = function () {
    var firstWeekday = new Date(this.getFullYear(), this.getMonth(), 1).getDay();
    var offsetDate = this.getDate() + firstWeekday - 1;
    return Math.floor(offsetDate / 7);
}

Date.prototype.toDateString = function (minimal = false) {
    if(minimal)
        return this.getDate().nth() + ' ' + this.getStrMonth();
    else
        return this.getStrDay('short') + ' ' + this.getDate().nth() + ' ' + this.getStrMonth() + ' ' + this.getFullYear();
}

Date.prototype.toShortDateString = function ($prefixzero = false, seperator = '-', monthOption = 'number', reverse = false) {
    var month = "";
    switch (monthOption) {
        case 'short':
            month = this.getStrMonth('short');
            break;
        case 'long':
            month = this.getStrMonth('long');
            break;
        case 'number':
            //To use default
        default:
            month = ($prefixzero && this.getMonth()+1 < 10 ? '0' : '' ) + (this.getMonth()+1)
            break;
    }
    var result = [
        this.getFullYear(),
        month,
        ($prefixzero && this.getDate() < 10 ? '0' : '' ) + this.getDate()
    ]

    return (reverse ? result.reverse().join(seperator) : result.join(seperator));
}

Date.prototype.getAge = function (from_date = Date.now()) {
    var ageDifMs = from_date - this.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getFullYear() - 1970);
}

Date.getMonths = function () {
    return {1: 'January', 2: 'February', 3: 'March', 4: 'April', 5: 'May', 6: 'June', 7: 'July', 8: 'August', 9: 'September', 10: 'October', 11: 'November', 12: 'December'}
}

Date.prototype.isValid = function () {
    return this.getTime() === this.getTime();
};

Date.prototype.isToday = function () {
    return this.toShortDateString(true) == (new Date()).toShortDateString(true);
}

Date.prototype.transformUTC = function () {
    let date =  new Date(this);
    date.setTime( date.getTime() + date.getTimezoneOffset()*60*1000 );
    return date;
}



// WEBPACK FOOTER //
// ./src/api/prototypes/Date.js